import { realFileType } from '@modules/_shared/components/chat/chatAttachments';
import {
  chatApiBase,
  chatFetch,
  getChatHeaders,
} from '@modules/_shared/components/chat/chatFetch';

// Full-quality originals of photos the composer resized (see
// fileToFileUIPart). They are stored next to the resized attachment, keyed by
// its attachmentId, and never sent to the model.

const attachmentUrl = (chatId: string, attachmentId: string) =>
  `${chatApiBase}/${encodeURIComponent(
    chatId,
  )}/attachments/${encodeURIComponent(attachmentId)}`;

// Best effort: the resized copy is what the conversation needs, so a failed
// upload only means downloads and property saves fall back to it.
export const uploadAttachmentOriginal = async ({
  chatId,
  attachmentId,
  file,
}: {
  chatId: string;
  attachmentId: string;
  file: File;
}): Promise<void> => {
  try {
    const res = await chatFetch(
      `${attachmentUrl(chatId, attachmentId)}/original`,
      {
        method: 'PUT',
        headers: {
          ...getChatHeaders(),
          'Content-Type': await realFileType(file),
        },
        body: file,
      },
    );
    if (!res.ok) {
      const body = await res.text().catch(() => '');
      console.warn(
        `Chat attachment original upload failed (${res.status}): ${body}`,
      );
    }
  } catch (error) {
    console.warn('Chat attachment original upload failed:', error);
  }
};

export const fetchAttachmentDownloadUrl = async ({
  chatId,
  attachmentId,
  filename,
}: {
  chatId: string;
  attachmentId: string;
  filename?: string;
}): Promise<string> => {
  const query =
    filename != null && filename !== ''
      ? `?filename=${encodeURIComponent(filename)}`
      : '';
  const res = await chatFetch(
    `${attachmentUrl(chatId, attachmentId)}/download${query}`,
    { headers: getChatHeaders() },
  );
  const body = await res.text();
  if (!res.ok) {
    throw new Error(`${res.status} ${res.statusText}: ${body}`);
  }
  let url: unknown;
  try {
    url = (JSON.parse(body) as { url?: unknown }).url;
  } catch {
    url = undefined;
  }
  if (typeof url !== 'string' || url === '') {
    throw new Error(`Unexpected download response: ${body}`);
  }
  return url;
};
